import {h, JSX} from 'preact'
import {Modal} from './Modal'

export interface ConfirmationModalProps {
    title: string;
    confirmButtonLabel: string;
    cancelButtonLabel: string;
    show: boolean;
    toggleModal: () => void;
    submit: () => void;
}

export const ConfirmationModal = (props: ConfirmationModalProps): JSX.Element => (
    <Modal
        show={props.show}
        toggleModal={props.toggleModal}
        title={props.title}
        hasCloseButton
    >
        <div class='flex items-center justify-center gap-6 py-12 px-16'>
            <button
                className={'grow text-base px-4 py-6 font-semibold min-w-[160px] btn btn-red'}
                onClick={props.toggleModal}
            >
                {props.cancelButtonLabel}
            </button>
            <button
                className={'grow text-base px-4 py-6 font-semibold min-w-[160px] btn btn-light-blue'}
                onClick={props.submit}
            >
                {props.confirmButtonLabel}
            </button>
        </div>
    </Modal>
);
